import { notificationConstants } from '../../_constants';

export function notification(state = {}, action) {
    switch (action.type) {
        case notificationConstants.NOTIFICATION_FETCHING:
            return {
                ...state,
                notificationFetching: true,
            };
        case notificationConstants.NOTIFICATION_FETCHED:
            return {
                ...state,
                notificationFetching: false,
            };
        case notificationConstants.NOTIFICATION_SUBMITTING:
            return {
                ...state,
                notificationSubmitting: true,
            };
        case notificationConstants.NOTIFICATION_SUBMITTED:
            return {
                ...state,
                notificationSubmitting: false,
            };
        case notificationConstants.GET_NOTIFICATION_LOGS:
            return {
                ...state,
                NotificationLogs: action.NotificationLogs,
            };
        case notificationConstants.GET_ALL_NOTIFICATIONS:
            return {
                ...state,
                AllNotifications: action.AllNotifications,
            };
        case notificationConstants.CLEAR_ALL_NOTIFICATIONS:
            return {
                ...state,
                AllNotifications: [],
            };
        default:
            return state;
    }
}